import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import moment from 'moment-timezone'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { getPickWindow } from '@severed-links/common.redherrings-reducers/terminator'
import * as s from './FootballMenuStatusBar.scss'

const TerminatorMenuStatusBar = () => {
  const state = useSelector(state => state.terminator)
  const isFetching = useSelector(state => state.terminator.isFetching || state.terminatorAdmin.isFetching)
  const timezone = useSelector(state => state.account.time_zone) || moment.tz.guess()
  const [now, setNow] = useState(Date.now())
  const navigate = useNavigate()
  const { pathname } = useLocation()
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [])
  const window = getPickWindow(state, now)
  const deadline = moment(window.deadline).tz(timezone)
  const urgent = window.hasDeadline && !window.afterDeadline && deadline.diff(now, 'minutes') <= 60
  const status = !window.hasDeadline ? '---' : window.afterDeadline ? 'Passed' : urgent ? deadline.from(moment(now)) : deadline.format(deadline.isSame(moment(now).tz(timezone), 'day') ? 'h:mm a' : 'M/D/YYYY h:mm a')
  useEffect(() => {
    if (window.afterDeadline && pathname === '/terminator/enter-pick') navigate('/terminator', { replace: true })
  }, [window.afterDeadline, pathname, navigate])
  return <div className={s.statusBar}><div className={s.container}>
    {isFetching ? <FontAwesomeIcon name='circle-notch' spin className={s.spinner} /> : null}
    <span className={s.details}><b><FontAwesomeIcon name='leaf' /> <span className={s.hideSmall}>Season:</span></b> <span className={s.hideSmall}>{state.seasonName}</span> {state.seasonMode}</span>
    {window.isPlayingSeason ? <>
      <span className={s.details}><b><FontAwesomeIcon name='calendar' /> Week:</b> {window.week}</span>
      <span className={`${s.details} ${urgent ? s.urgent : ''}`}><b><FontAwesomeIcon name='clock' /> <span className={s.hideSmall}>Pick Deadline:</span></b> {status}</span>
    </> : null}
  </div></div>
}
export default TerminatorMenuStatusBar
